export default "__VITE_ASSET__D_vL98nf__"